import { Component, OnDestroy, OnInit, HostListener, Inject, AfterViewChecked, AfterViewInit } from '@angular/core';

import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationState, getApplicationState, GetIsAdminUser, GetProfilePicture, getProfilePicture, Heartbeat } from '../app/state-management/';
import { SetMapState } from 'dnv-lib';
import { ConfigService } from './services/config.service';

import { State, AuthConfig, AuthLoginFailure, AuthLoginSuccess, UpdateWindowSize, DelayedAction } from './state-management';
import * as fromEnvironment from '../environments/environment';
import { Observable, Subject, interval, Subscription } from 'rxjs';
import { Problem } from '../../src/app/models/problem';
import { takeUntil, map, catchError, filter } from 'rxjs/operators';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  private readonly destroying$ = new Subject<void>();
  isIframe = false;
  loggedIn = false;
  environment = fromEnvironment.environment;

  private ngUnsubscribe: Subject<void> = new Subject();

  problems$: Observable<Problem[]>;
  application$: Observable<ApplicationState>;
  profilePicture$: Observable<Blob>;

  // heartbeatSubscription: Subscription;

  access: boolean;
  profilePicture: Blob = null;
  isAdminUser: boolean = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private broadcastService: MsalBroadcastService,
    private authService: MsalService,
    private configService: ConfigService,
    private store: Store<{}>,
  ) {
    this.application$ = this.store.select(getApplicationState);
    this.store.dispatch(new AuthConfig({ authService, broadcastService }));
    
    this.profilePicture$ = this.store.select(getProfilePicture);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.store.dispatch(new UpdateWindowSize({
      windowInnerHeight: event.target.innerHeight,
      windowInnerWidth: event.target.innerWidth
    }));
  }

  ngOnInit() {
    this.application$
      .pipe(
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(appState => {
        this.access = appState.access;
        this.isAdminUser = appState.admin.isAdmin;
      });

      this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroying$)
      )
      .subscribe(() => {
        this.checkAccount();

        if (this.loggedIn) {
          this.store.dispatch(new GetProfilePicture());
          this.store.dispatch(new GetIsAdminUser());
          this.store.dispatch(new SetMapState(this.configService.initialDnvMapState()));
        }
      });

      // this.broadcastService.msalSubject$
      //   .pipe(
      //     filter(msg => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
      //     takeUntil(this.destroying$)
      //   )
      //   .subscribe((result) => {
      //     this.checkAccount();
      //   });

      this.profilePicture$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(profilePicture => this.profilePicture = profilePicture);
  }

  ngOnDestroy() {
    this.destroying$.next(null);
    this.destroying$.complete();
  }

  checkAccount(): void {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
    if (this.loggedIn) {
      this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]);
    }
  }

  login(): void {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
        .subscribe((response: AuthenticationResult) => this.authService.instance.setActiveAccount(response.account));
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      } else {
        this.authService.loginRedirect();
    }
    }
  }
}
